<template>
    <v-container>
            <v-card
                max-width="600"
                tile
            >
                <v-list class="py-0 lg8" color="secondary">
                    <v-list-item-group v-model="people">
                        <v-list-item v-for="(person, i) in people"
                                     :key="i"
                                     color="secondary"
                                     text
                                     rounded
                                     class="my-0">
                            <v-list-item-content>
                                <v-card color="primary lighten-1" class="white--text">

                                    <v-card-title primary-title>
                                        <div class="headline">
                                            {{person.last_name}} {{person.first_name}}
                                        </div>
                                    </v-card-title>
                                    <v-card-text>
                                        <v-layout>
                                            <v-flex xs2>
                                                <v-img
                                                        v-if="person.img"
                                                        :src="person.img"
                                                        height="125px"
                                                        contain
                                                ></v-img>
                                                <v-img
                                                        v-else
                                                        src="@/assets/logo.png"
                                                        height="125px"
                                                        contain
                                                ></v-img>
                                            </v-flex>
                                            <v-flex xs10>
                                                <span>
                                                    <ul>
                                                        <li v-if="person.title">{{person.title}}</li>
                                                        <li v-if="person.phone_number_1"><v-icon>mdi-phone</v-icon>{{person.phone_number_1}}</li>
                                                        <li v-if="person.phone_number_2"><v-icon>mdi-phone</v-icon>{{person.phone_number_2}}</li>
                                                        <li v-if="person.whatsapp"><v-icon>mdi-whatsapp</v-icon>{{person.whatsapp}}</li>
                                                        <li v-if="person.wechat"><v-icon>mdi-wechat</v-icon>{{person.wechat}}</li>
                                                    </ul>
                                                </span>
                                            </v-flex>
                                        </v-layout>
                                    </v-card-text>
                                </v-card>

                            </v-list-item-content>
                        </v-list-item>
                    </v-list-item-group>
                </v-list>
            </v-card>
    </v-container>
</template>

<script>
    export default {
        name: "ContactPage",
        data () {
            return {
                people: [
                    {
                        first_name: 'Gretl',
                        last_name: 'Wolfram',
                        title: 'Voorzitter',
                        phone_number_1: '+597 8769765',
                        phone_number_2: '',
                        wechat: '',
                        whatsapp: '+597 8769765',
                        img: ''
                    },
                    {
                        first_name: 'Ensin',
                        last_name: 'Lam',
                        title: 'Onder Voorzitter',
                        phone_number_1: '+597 8999992',
                        phone_number_2: '+597 8716688',
                        wechat: 'ensinlam888',
                        whatsapp: '+597 8999992',
                        img: ''
                    },
                ]
            }
        }
    }
</script>

<style scoped>
    ul {
        list-style-type: none;
    }
</style>